<template>
  <b-modal
    id="addVellosForm"
    class="vellos-form"
    :title="form_title"
    :headerClass="`add-vello-icon`"
    centered
    hide-footer
  >
    <template v-slot:modal-title>
      {{ form_title }}
      <b-link
        href="https://vello.vip/faqs/"
        target="_blank"
        title="Learn more about Vellos"
      >
        <b-img
          src="~@/assets/img/info.svg"
          class="d-inline-block mt-n1"
          height="25px"
        />
      </b-link>
    </template>
    <b-overlay
      :show="loading"
      rounded="sm"
      variant="transparent"
      opacity="1"
      blur="1px"
    >
      <b-container v-if="packages">
        <b-row v-if="isVelloPackEnabled">
          <b-col class="text-center mt-n4">
            <b-form @submit.prevent="proceedSubscribe">
              <b-row v-if="showCard && showDefaultCard">
                <b-col>
                  <b-form-group>
                    <add-card
                      :type="selected_type"
                      @cancel="showCard = false"
                      @complete="
                        ;(showCard = false),
                          (showDefaultCard = false),
                          proceedSubscribe()
                      "
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-else>
                <b-col class="mt-4">
                  <b-form-group v-if="false">
                    <b-form-radio-group
                      class="package_switch package_type"
                      v-model="selected_type"
                      :options="type_options"
                      buttons
                      button-variant="black"
                    ></b-form-radio-group>
                  </b-form-group>

                  <b-form-group class="package_switch mt-2">
                    <b-form-radio-group
                      class="package_value width_equal"
                      v-model="selected_vello"
                      :options="vello_packages"
                      buttons
                      button-variant="black"
                      text-field="pack"
                      value-field="plan"
                    ></b-form-radio-group>
                  </b-form-group>

                  <div
                    class="package_description"
                    v-if="selected_vello.name === `Standard`"
                  >
                    <b-img
                      class="my-3"
                      src="~@/assets/img/video_standard.svg"
                      alt="AR Video Icon"
                    />
                    <h6 class="my-3">Standard</h6>
                    <p class="text-15 grey-light">
                      Connect directly via video message. Send your video
                      message and they will send back a video reply.
                    </p>
                  </div>

                  <div
                    class="package_description"
                    v-if="selected_vello.name === `AR`"
                  >
                    <b-img
                      class="my-3"
                      src="~@/assets/img/video_ar.svg"
                      alt="AR Video Icon"
                    />
                    <h6 class="my-3">Augmented Reality</h6>
                    <p class="text-15 grey-light">
                      Send a video message. They will send an AR reply.
                      Virtually 'place' the influencer in your space as if they
                      are responding right in front of you.
                    </p>
                  </div>

                  <b-form-group class="mt-4">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="radius-15 py-3 px-4"
                      style="min-width: 300px"
                      type="submit"
                    >
                      {{ selected_type }}
                      <span v-if="isMonthly">
                        ({{ pay.symbol + ` ` + pay.price }}/month)
                      </span>
                      <span v-else>{{ pay.symbol + ` ` + pay.price }}</span>
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import AddCard from './AddCard'

export default {
  name: 'AddVellosModal',
  components: { AddCard },
  props: ['subscription_id'],

  data() {
    return {
      selected_type: 'Purchase',
      selected_monthly: null,
      selected_single: null,
      selected_vello: {},
      loading: false,
      showCard: false,
      showDefaultCard: true,
      vello_packages: [],
    }
  },

  computed: {
    ...mapState({
      card: (state) => state.auth.card,
      profile: (state) => state.influencer.profile,
      packages: (state) => state.influencer.packages,
      package_settings: (state) => state.influencer.package_settings,
    }),

    isVelloPackEnabled: function () {
      if (this.package_settings) {
        if (this.package_settings.is_monthly_pack_enabled) {
          return true
        } else if (this.package_settings.is_single_pack_enabled) {
          return true
        }
      }
      return false
    },

    isMonthly: function () {
      return this.selected_type === 'Subscribe'
    },

    form_title: function () {
      let name = `@` + this.profile.influencer.username

      if (this.profile.influencer.full_name) {
        name = this.profile.influencer.full_name
      }

      return `Vello with ` + name
    },

    type_options: function () {
      if (this.subscription_id) {
        return [{ text: 'Monthly', value: 'Subscribe' }]
      }

      return [
        { text: 'Monthly', value: 'Subscribe' },
        { text: 'Single', value: 'Purchase' },
      ]
    },

    pay: function () {
      if (this.selected_vello) {
        return this.selected_vello
      }

      return {
        quantity: 0,
        price: 0,
      }
    },
  },

  methods: {
    ...mapActions({
      getPackagePricing: 'influencer/getPackagePricing',
      getProfile: 'influencer/getProfile',
    }),
    ...mapMutations({
      clearPackages: 'influencer/clearPackages',
    }),

    async proceedSubscribe() {
      if (!this.card || this.showDefaultCard) {
        this.showCard = true
        return
      }

      this.showDefaultCard = true
      this.showCard = false
      this.loading = true

      let params = {
        package_id: this.pay.package_id,
        influencer_uid: this.profile.influencer.influencer_uid,
      }
      let endpoint = `influencer/${params.influencer_uid}/subscribe`
      let apiRequest = this.$api.post(endpoint, params)

      if (this.isMonthly && this.subscription_id) {
        params = {
          switch_to_package_id: params.package_id,
          influencer_uid: params.influencer_uid,
        }
        endpoint = `subscription/${this.subscription_id}/change`
        apiRequest = this.$api.put(endpoint, params)
      }

      await apiRequest
        .then(({ data }) => {
          this.loading = false
          this.showToast('success', data.message)

          // reload profile
          this.getProfile(params.influencer_uid)
          this.$emit('done')
        })
        .catch((error) => {
          this.loading = false
          this.showToast('danger', error.response.data.message)
        })

      this.$root.$emit('bv::hide::modal', 'addVellosForm')
    },

    showToast(type, message) {
      this.$bvToast.toast(message, {
        variant: type,
        noCloseButton: true,
        toaster: 'b-toaster-bottom-right',
      })
    },

    async setVelloPackages() {
      if (this.package_settings.is_augmented_pack_enabled) {
        await this.pushVelloPackage(this.packages.augmented)
      }
      if (this.package_settings.is_single_pack_enabled) {
        await this.pushVelloPackage(this.packages.single)
      }
      this.selected_vello = this.vello_packages[0].plan
    },

    pushVelloPackage(pack) {
      this.vello_packages.push(pack)
    },
  },

  async created() {
    if (this.profile) {
      await this.getPackagePricing(this.profile.influencer.influencer_uid)

      if (this.packages) {
        await this.setVelloPackages()

        this.profile.influencer.package_settings = this.package_settings
      }
    }
  },

  async destroyed() {
    await this.clearPackages()
  },
}
</script>

<style lang="scss" scoped></style>
